import { IAsset } from "../../../../../types/file-attachment.interface";

import { IAssetsTableColumnsOptions } from "../../types/file-upload-assets-table.interface";

import { FileActions } from "./file-actions.component";

export const renderFileActions = (asset: IAsset, options: IAssetsTableColumnsOptions) => (
  <FileActions
    asset={asset}
    canDelete={options.canDelete}
    onDelete={options.onDelete}
    showDeleteButton={options.showDeleteButton}
  />
);
